import ActionTypes from '../constants';

const initialState = {
    suppliers: {},
    supplier: {}
    // loading: false,
};

const supplierReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETSUPPLIERSUCCESS:
            return {
                ...state,
                suppliers: action.payload,
            }
        case ActionTypes.GETSUPPLIERBYIDSUCCESS:
            return {
                ...state,
                supplier: action.payload,
            }
        default:
            return state;
    }
}

export default supplierReducer;